import React, { FC, useEffect, useRef, useState } from "react";
import classes from "./NavbarMobile.module.css";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../Store/hooks";
import { motion } from "framer-motion";
import { logoutUser } from "../Slices/userSlice";
import { toast } from "react-toastify";
import { toggleSearchModal } from "../Slices/searchModalSlice";
import { toggleWatchlistModal } from "../Slices/watchlistModalSlice";
import { toggleUserRatingsModal } from "../Slices/userRatingsModalSlice";
import { toggleProfileModal } from "../Slices/profileModalSlice";
import { toggleUnsubModal } from "../Slices/unsubModalSlice";

type NavbarMobileProps = {
  applyPadding?: boolean;
};

const NavbarMobile: FC<NavbarMobileProps> = ({ applyPadding }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const targetRef = useRef<HTMLDivElement>(null);

  const { user } = useAppSelector((state) => state.userSlice);

  const handleNavigate: (link: string) => void = (link) => {
    navigate(link, { state: { reset: true } });
  };
  const [toggle, setToggle] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    console.log(targetRef, "tr");
    if (targetRef.current) {
      console.log(targetRef?.current, "tc");
      console.log(targetRef.current?.offsetHeight, "ofh");
      setHeight(targetRef.current?.offsetHeight);
    }
  }, [targetRef, toggle]);

  const signoutHandler = () => {
    setToggle(false);
    dispatch(logoutUser(null));
    navigate("/");

    toast.success("Sign out successfully!");
  };

  const handleWatchListClick = () => {
    setToggle(false);
    dispatch(toggleWatchlistModal());
  };

  const handleRatingsClick = () => {
    setToggle(false);
    dispatch(toggleUserRatingsModal());
  };

  const handleProfileClick = () => {
    setToggle(false);
    dispatch(toggleProfileModal());
  };

  return (
    <header className={`${classes.header} ${applyPadding && classes.padding}`}>
      <nav className={`${classes.mobile_navbar}`}>
        <button
          className={classes.logo_container}
          onClick={() => navigate("/home")}
        >
          <img
            src="/assets/images/logo2.png"
            alt="logo"
            className={classes.logo}
          />
        </button>
        <div className={classes.nav_buttons_container}>
          <button
            type="button"
            className={classes.nav_link_search}
            onClick={() => dispatch(toggleSearchModal())}
          >
            <i className={`${classes.icon} pi pi-search`} />
          </button>
          {/* <div className={classes.profile_container}>
          <div className={classes.avatar}>
            <i className={`${classes.avatar_icon} pi pi-user`} />
          </div>
        </div> */}

          <motion.div
            className={classes.profile_container}
            onClick={() => setToggle((prevValue) => !prevValue)}
          >
            <div className={classes.avatar}>
              {toggle ? (
                <i className={`${classes.avatar_icon} pi pi-times`} />
              ) : (
                <i className={`${classes.avatar_icon} pi pi-user`} />
              )}
            </div>

            <motion.div
              data-isOpen={toggle}
              layout
              ref={targetRef}
              className={classes.profile_menu}
              transition={{
                type: "spring",
                stiffness: 700,
                damping: 30,
              }}
              style={{ bottom: `calc(-${height}px - 10px)` }}
              onClick={() => setToggle((prevValue) => !prevValue)}
            >
              {toggle ? (
                <>
                  {user ? (
                    <>
                      <button
                        className={classes.signin}
                        onClick={() => handleWatchListClick()}
                      >
                        Your Watchlist
                      </button>
                      <button
                        className={classes.signin}
                        onClick={() => handleRatingsClick()}
                      >
                        Your Ratings
                      </button>
                      <button
                        className={classes.signin}
                        onClick={handleProfileClick}
                      >
                        Profile
                      </button>
                      <button
                        className={classes.signin}
                        onClick={() => navigate("/privacy-policy")}
                      >
                        Privacy Policy
                      </button>
                      <button
                        className={classes.signout}
                        onClick={signoutHandler}
                      >
                        Sign out
                      </button>
                      <button
                        className={classes.deactivate}
                        onClick={() => dispatch(toggleUnsubModal())}
                      >
                        Unsubscribe
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className={classes.signin}
                        onClick={() => navigate("/privacy-policy")}
                      >
                        Privacy Policy
                      </button>
                      {/* <button
                        className={classes.signin}
                        onClick={handleSigninClick}
                      >
                        Sign In
                      </button>

                      <div className={classes.wrapper}>
                        <p className={classes.new_user_text}>New User?</p>
                        <button
                          type="button"
                          className={classes.signup}
                          onClick={handleSignupClick}
                        >
                          Create Account
                        </button>
                      </div> */}
                    </>
                  )}
                </>
              ) : null}
            </motion.div>
          </motion.div>
        </div>
      </nav>
    </header>
  );
};

export default NavbarMobile;
